import PackStep1Image from 'public/images/shipskis/pack-page-1.jpg'
import PackStep2Image from 'public/images/shipskis/pack-page-2.jpg'
import PackStep3Image from 'public/images/shipskis/pack-page-3.jpg'
import HeroBackgroundImage from 'public/images/shipskis/pack-page-hero.jpg'

import { PackPageContent, PackStep } from './shipsticks.page.content'

const hero = {
  backgroundImage:
    typeof HeroBackgroundImage === 'string' ? HeroBackgroundImage : HeroBackgroundImage.src,
  header: 'Pack and tag your winter gear.',
  subHeader: 'It’s easy to get your gear ready to ship–here’s how.',
}

const newsletterSignup = {
  title: "Let's talk.",
  subtitle:
    'Becoming a ShipSkis partner is simple, fast and completely free. ' +
    "We'll help you get set up, support your team, and provide the tools you " +
    'need to deliver a better experience from the moment guests book their trip',
}

const steps: PackStep[] = [
  {
    header: "What you'll need",
    items: [
      {
        icon: 'check-circle-filled',
        header: '',
        body: 'A soft travel bag, a hard case, or a box',
        isRequired: true,
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: `
                Two copies of your shipping label — print from your account or
                confirmation email. If your shipment originates in the U.S.
                and is booked at least three business days in advance, we’ll
                mail labels to your chosen address
        `,
        isRequired: true,
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: 'Clear packing tape',
        isRequired: true,
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: (
          <div>
            <strong>OPTIONAL:</strong> For soft bags, a shipping luggage tag (aka a fly tag) and zip
            tie available at most carrier stores
          </div>
        ),
        isRequired: false,
      },
    ],
  },
  {
    header: (
      <>
        <strong>Step 1:</strong>{' '}
        <span style={{ fontSize: '0.9em' }}>Prepare your skis & snowboards.</span>
      </>
    ),
    image: typeof PackStep1Image === 'string' ? PackStep1Image : PackStep1Image.src,
    items: [
      {
        icon: 'check-circle-filled',
        header: '',
        body: `
                Protect vulnerable parts—like bindings, tips, and tails—with
                bubble wrap or cardboard for extra cushioning during transit.
        `,
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: (
          <div>
            <strong>Note:</strong> Some skiers prefer to secure or remove ski brakes before
            shipping, for added peace of mind. (If you don&apos;t want to remove yours, rubber bands
            or cable ties can be used to keep brakes flush against the skis.)
          </div>
        ),
      },
    ],
  },
  {
    header: (
      <>
        <strong>Step 2:</strong> <span style={{ fontSize: '0.9em' }}>Pack your gear</span>
      </>
    ),
    image: typeof PackStep2Image === 'string' ? PackStep2Image : PackStep2Image.src,
    items: [
      {
        icon: 'check-circle-filled',
        header: '',
        body: 'Place your skis or snowboard in your travel bag, hard case, or shipping box.',
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: 'Place one copy of the shipping label inside.',
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: (
          <div>
            <strong>For hard cases and soft bags:</strong> Close the case or bag, and pull any
            straps tight.
          </div>
        ),
      },
      {
        icon: 'check-circle-filled',
        header: '',
        body: (
          <div>
            <strong>For boxes:</strong> Tape the box&apos;s seams closed using at least 3 strips of
            tape at each end.
          </div>
        ),
      },
    ],
  },
  {
    header: (
      <>
        <strong>Step 3:</strong> <span style={{ fontSize: '0.9em' }}>Attach the label</span>
      </>
    ),
    image: typeof PackStep3Image === 'string' ? PackStep3Image : PackStep3Image.src,
    items: [
      {
        header: '',
        body: `
                Domestic shipments booked at least 3 days in advance will
                receive labels, and—if not shipping in a box—luggage tags and
                zip ties. Otherwise, labels can be printed from your
                confirmation email or account, and tags and ties can be picked
                up at your local carrier store.
        `,
      },
      {
        header: '',
        body: `
                Boxes: Securely apply the provided shipping label to the
                outside of the box. If printing your own label, attach the
                label to the box using clear packing tape. Cover the entire
                label with tape and press to ensure it’s securely attached.
        `,
      },
      {
        header: '',
        body: `
                Hard cases and soft bags: Attach the label (in its luggage tag)
                to the handle and secure it with the zip tie.
        `,
      },
    ],
  },
]

const tableData = [
  {
    do: 'Do add extra padding, if you like, such as a jacket or even bubble wrap.',
    "don't": "Don't tape your label to canvas as it might fall off in transit.",
  },
  {
    do: 'Do ensure that everything is clean and dry before packing.',
    "don't": "Don't skimp on the packing tape.",
  },
  {
    do: `
          Do consider dropping your gear at a carrier store—and letting them
          attach the label—or purchasing luggage tags.
    `,
    "don't": `
              Don't forget to keep all bags and cases unlocked for customs
              inspection when traveling internationally.
    `,
  },
]

const content: PackPageContent = {
  hero,
  newsletterSignup,
  steps,
  tableData,
}

export default content
